import React from 'react';
import { MailboxManagementApiClient } from '@wix/domains-serverless-interface/react-kit';
import { ConnectedDomainSuccessPage } from './ConnectedDomainSuccessPage';
import { EmailSaleSuccessPage, } from './EmailSaleSuccessPage';
export const ConnectSuccessPage = (props) => {
    const canPurchaseMailboxState = MailboxManagementApiClient.hooks.useCanPurchase({
        domainName: props.siteDomain,
    });
    if (canPurchaseMailboxState.isLoading) {
        return null;
    }
    return canPurchaseMailboxState.data?.canPurchase ? (React.createElement(EmailSaleSuccessPage, { ...props })) : (React.createElement(ConnectedDomainSuccessPage, { ...props }));
};
//# sourceMappingURL=ConnectSuccessPage.js.map